import React from 'react';
import { styles } from './styles';
import SectionWrapper from '../../components/sectionWrapper/sectionWrapper';
import SandwichContainer from '../../components/sandwichContainer/sandwichContainer';
import { pad2 } from '../../utils';

type Product = { title: string; description: string; detail?: React.ReactNode };

// Named + expandable ("More") products are far enough along to reveal; nameless
// + "Coming soon" ones are still under wraps. The two formats encode disclosure
// stage, not decoration — items graduate from the latter to the former.
const IN_DEV: Product[] = [
  {
    title: 'Find your players',
    description:
      'A social platform that connects gamers with the people they actually want to play with.',
  },
  {
    title: 'A new take on tower defense',
    description: 'An original game that reimagines a genre we grew up on.',
  },
  {
    title: 'VAE AI',
    description:
      'A versatile AI assistant that lives inside your software, custom-tailored to exactly what it does.',
    detail: (
      <div>
        <p style={styles.detailText}>
          VAE is Novaeon&apos;s own AI, built to live inside your product rather than beside
          it. We shape it to your software&apos;s purpose: a sharp operator in a business
          app, a master chef in a cooking app, a guide who has lived among the stars in an
          astrology app. One AI, tailored to whatever you&apos;re building and integrated from
          day one.
        </p>
        <div style={styles.detailTags}>
          <span style={styles.detailTag}>AI</span>
          <span style={styles.detailTag}>Integrated</span>
          <span style={styles.detailTag}>Custom-tailored</span>
        </div>
      </div>
    ),
  },
];

const Products: React.FC = () => {
  return (
    <SectionWrapper
      id="products"
      label="Products"
      heading="Built in-house"
      sub="A look at what we're building right now."
    >
      <div style={styles.group}>
        <h3 style={styles.groupHead}>In the lab</h3>
        <div style={styles.list}>
          {IN_DEV.map((p, i) => (
            <SandwichContainer
              key={p.title}
              index={pad2(i)}
              title={p.title}
              description={p.description}
              isLast={i === IN_DEV.length - 1}
            >
              {p.detail}
            </SandwichContainer>
          ))}
        </div>
      </div>

      {/* <div style={styles.group}>
        <h3 style={styles.groupHead}>Out in the world</h3>
        <div style={styles.list}>
          <SandwichContainer
            index="01"
            title="Placeholder product"
            description="A one-line description of a released product."
            isLast
          >
            <div>
              <p style={styles.detailText}>
                A fuller description of the product goes here: what it does, the problem it
                solves, and who it's for. This panel expands to reveal the full details of a
                released product.
              </p>
              <div style={styles.detailTags}>
                <span style={styles.detailTag}>Web</span>
                <span style={styles.detailTag}>iOS</span>
                <span style={styles.detailTag}>2026</span>
              </div>
              <span style={styles.detailLink}>Visit product →</span>
            </div>
          </SandwichContainer>
        </div>
      </div> */}
    </SectionWrapper>
  );
};

export default Products;
